import ImageFrame from './ImageFrame'
import ImagePlaceholderFrame from './ImagePlaceholderFrame'

export default class PickerControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.property = document.createElement('div')
    this.property.className = 'contact'
    this.property.onclick = args.readonly ? null : args.onclick
    this.value = args.value
    this.item = args.item
    this.image = undefined
    this.placeholder = undefined
    this.onchange = args.onchange

    if (this.item && this.item.getImage()) {
      this.image = new ImageFrame(this.property, {
        image: this.item.getImage()
      })
    } else {
      this.placeholder = new ImagePlaceholderFrame(this.property, {
        title: this.item ? this.item.getTitle() : null
      })
    }

    let dl = document.createElement('dl')
    this.dt = document.createElement('dt')
    this.dt.innerHTML = this.item ? this.item.getTitle() : 'Onbekend'
    this.dd = document.createElement('dd')
    this.dd.innerHTML = this.item ? this.item.getSubtitle() : ''

    dl.appendChild(this.dt)
    dl.appendChild(this.dd)
    this.property.appendChild(dl)

    let button = document.createElement('button')
    button.className = 'icon'
    button.innerHTML = '\ue06d'
    button.onclick = () => {
      if (args.onselect) {
        args.onselect(this.item)
      }
    }

    div.appendChild(this.label)
    div.appendChild(this.property)
    div.appendChild(button)

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)

    element.appendChild(fragment)
  }

  getTitle () {
    return this.dt.innerHTML
  }

  setTitle (text) {
    this.dt.innerHTML = text
  }

  getImage () {
    if (this.image) {
      return this.image.getImage()
    }
  }

  setImage (newImage) {
    if (!newImage) {
      if (this.placeholder) {
        this.placeholder.setTitle(this.item ? this.item.getTitle() : null)
      } else {
        this.placeholder = new ImagePlaceholderFrame(null, {title: this.item ? this.item.getTitle() : null})
        this.property.insertBefore(this.placeholder.getElement(), this.property.childNodes[0])
      }

      if (this.image) {
        this.property.removeChild(this.image.getElement())
        this.image = undefined
      }

      return
    }

    if (this.image) {
      this.image.setImage(newImage)
    } else {
      this.image = new ImageFrame(null, {image: newImage})
      this.property.insertBefore(this.image.getElement(), this.property.childNodes[0])
    }

    if (this.placeholder) {
      this.property.removeChild(this.placeholder.getElement())
      this.placeholder = undefined
    }
  }

  getSubtitle () {
    return this.dd.innerHTML
  }

  setSubtitle (text) {
    this.dd.innerHTML = text
  }

  getValue () {
    return this.value
  }

  getItem () {
    return this.item
  }

  setValue (newValue, newItem) {
    this.value = newValue
    this.item = newItem
    this.setImage(this.item && this.item.getImage ? this.item.getImage() : null)
    this.setTitle(this.item && this.item.getTitle ? this.item.getTitle() : 'Onbekend')
    this.setSubtitle(this.item && this.item.getSubtitle ? this.item.getSubtitle() : '')
  }

  setLabel (text) {
    this.label.innerHTML = text
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/PickerControl.js